import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy redirect: /warga/:slug → /desa/:slug/warga
export const Route = createFileRoute('/warga/$slug')({
  beforeLoad: async ({ params }) => {
    throw redirect({ to: `/desa/${params.slug}/warga` as any })
  },
  component: () => null,
})
